import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from "flarum/common/components/LoadingIndicator";
export default class adminPanelModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
  }
  className() {
    return 'Modal--large AdminPanelModal';
  }
  title() {
    return m("div", null, app.translator.trans('ziven-community-core.forum.admin-panel'));
  }
  content() {
    // app.forum.attribute('adminUrl')
    return m("div", null, m("div", {
      className: "Modal-body"
    }, m("iframe", {
      id: "adminPanelIframe",
      src: "/admin"
    })));
  }
}
flarum.reg.add('ziiven-ziven-core', 'forum/modal/adminPanelModal', adminPanelModal);